import ReactMap from "../../../shared/map/map";
import {OverlayView, OverlayViewF, PolygonF} from "@react-google-maps/api";
import mapData from "../../../data/mapData";
import car from "../../../assets/images/car-icon.svg";

const LiveTrackMap = () => {

    return(
        <ReactMap>
            {
                <PolygonF
                    path={mapData.cords}
                    options={{
                        fillColor: "yellow",
                        fillOpacity: 0,
                        strokeColor: "#44A9E1",
                        strokeOpacity: 1,
                        strokeWeight: 3
                    }}
                />
            }
            {
                mapData.alertLoc.steps.map((loc) =>
                    <OverlayViewF
                        key={loc.id}
                        position={loc.position}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    >
                        <div className={`icon width-25 overlay-marker`}
                             style={{transform: `translate3d(-50%, -50%, 0) rotate(${loc.rotate}deg)`}}>
                            <img src={car} alt=""/>
                        </div>
                    </OverlayViewF>
                )
            }

        </ReactMap>
    )
}

export default LiveTrackMap;
